import { SnackbarOrigin } from '@material-ui/core'
import { AlertProps } from '@material-ui/lab'
import { createSlice } from '@reduxjs/toolkit'
import { findIndex } from 'lodash'

import generateUniqueId from '../snackbar/uniq-id'

export type Notification = {
  key: string
  duration?: number
  anchorOrigin?: SnackbarOrigin
  message: string
  action?: {
    label: string
    link: string
  }
  severity?: AlertProps['severity']
}
type State = Notification[]

const initState: State = []

const snackbarSlice = createSlice({
  name: 'muiSnackbar',
  initialState: initState,
  reducers: {
    addNotification(state, action: { payload: Omit<Notification, 'key'> }) {
      state.push({ ...action.payload, key: generateUniqueId() })
    },
    removeNotification(state, action: { payload: string }) {
      const idx = findIndex(state, { key: action.payload })
      if (idx > -1) {
        state.splice(idx, 1)
      }
    },
  },
})

export const selectNotifications = (state: { muiSnackbar: State }) => state.muiSnackbar

export const { addNotification, removeNotification } = snackbarSlice.actions
export default snackbarSlice.reducer
